var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audio',{class:("audio-node__mode--" + _vm.mode),attrs:{"controls":"","src":_vm.filePath}})}
var staticRenderFns = []

export { render, staticRenderFns }